import { Injectable } from '@angular/core';
import { AttendanceStatus } from '../../interfaces/attendanceStatus';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AttendanceStatusService {
  constructor(private httpClient: HttpClient) {}

  getAttendanceStatus() {
    return this.httpClient
      .get<AttendanceStatus[]>(
        'assets/components/attendance-status/attendance-status.json'
      )
      .pipe(map((data) => data));
  }
}
